
import React from "react";
import { Helmet } from "react-helmet";

interface CountyHeaderProps {
  countyName: string;
  nursingHomeCount: number;
}

export function CountyHeader({ countyName, nursingHomeCount }: CountyHeaderProps) {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        {/* Preconnect hints only — title/meta/schema handled by CountySEO */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
      </Helmet>

      <div className="bg-grandpal-beige py-12">
        <div className="container">          
          <h1 className="text-4xl font-bold text-center mb-4 mt-6">
            Nursing Homes in {countyName} (Updated {currentYear})
          </h1>
          <p className="text-xl text-grandpal-gray text-center mb-8">
            Explore the most comprehensive and up-to-date list of nursing homes in {countyName}
          </p>
        </div>
      </div>
    </>
  );
}
